module.exports = __webpack_public_path__ + "static/img/friend02.79994561.png";